import React, { Component } from "react";
import '../css/bottomRight_UI.css';
import Twemoji from 'react-twemoji';
import Cookies from 'js-cookie';
import Tippy from "@tippyjs/react";
import 'tippy.js/dist/tippy.css';
import atlasIcon from '../img/atlas.svg'
import sextantIcon from '../img/sextant.svg'
import ancreIcon from '../img/ancre.svg'

class BottomRightUI extends Component {
    constructor(props) {
        super(props);

        this.handleAnchor = this.handleAnchor.bind(this);
        this.handleSail = this.handleSail.bind(this);


        this.state = {
            anchor: this.props.boatData.anchor,
            sails: this.props.boatData.sails
        }
    }

    componentDidUpdate(oldProps) {
        if ((oldProps.boatData.anchor !== this.props.boatData.anchor) || (oldProps.boatData.sails !== this.props.boatData.sails)) {
            this.setState({
                anchor: this.props.boatData.anchor,
                sails: this.props.boatData.sails
            })
        }
    }

    render() {
        if (this.props.boatData) {
            const boat = this.props.boatData;
            let sextaaantCheck = this.sextantCheck(boat.lat, boat.long, boat.weather);


            if (typeof (sextaaantCheck.coords[0]) == 'number') sextaaantCheck.coords[0] = sextaaantCheck.coords[0].toFixed(2);
            if (typeof (sextaaantCheck.coords[1]) == 'number') sextaaantCheck.coords[1] = sextaaantCheck.coords[1].toFixed(2);


            return (
                <div id="bottomRight_UI">

                    <div className="boatButtons">
                        <Tippy content={this.state.sail ? 'Baisser les voiles' : 'Monter les voiles'} allowHTML='true' theme='custom' placement='auto'>
                            <span id="sailsControl" onClick={this.handleSail} class={this.state.sails ? 'sailUp' : 'sailDown'}><Twemoji options={{ folder: 'svg', ext: '.svg' }}>⛵</Twemoji></span>
                        </Tippy><br />
                        <Tippy content={this.state.anchor ? 'Remonter l\'ancre' : 'Descendre l\'ancre'} allowHTML='true' theme='custom' placement='auto' >
                            <span onClick={this.handleAnchor} className={this.state.anchor ? 'bottomRightButton anchorDown' : 'bottomRightButton anchorUp'}>
                                {/* <Twemoji options={{ folder: 'svg', ext: '.svg' }}>⚓</Twemoji> */}

                                <img src={ancreIcon} alt='Discord' />
                            </span>
                        </Tippy>
                    </div>

                    <div className="mapButtons">
                        <Tippy content={sextaaantCheck.message} allowHTML='true' theme='custom' placement='auto'>
                            <span className="bottomRightButton" onClick={this.props.toggleLogs}>
                                <img src={sextantIcon} alt='Discord' />
                                <span id="sextant_coords">
                                    <span id="sextant_lat">{sextaaantCheck.coords[0]} °</span>
                                    <span id="sextant_long">{sextaaantCheck.coords[1]} °</span>
                                </span>
                            </span>
                        </Tippy><br />
                        <Tippy content="Ouvrir l'atlas de navigation" allowHTML='true' theme='custom' placement='auto'>
                            <span className="bottomRightButton" onClick={this.props.toggleNavigationMap}>
                                {/* <Twemoji options={{ folder: 'svg', ext: '.svg' }}>🗺️</Twemoji> */}
                                <img src={atlasIcon} alt='Discord' />
                            </span>
                        </Tippy>
                    </div>
                </div>
            );
        } else {
            return <div></div>
        }
    }

    sextantCheck(lat, long, weather) {
        if (weather.clouds.all > 40) { // Too much clouds
            // sextantTooltip[0].setContent(sextantTextElement.innerHTML);
            return { coords: ['?', '?'], message: 'Il y a trop de nuages pour déterminer la position.' };
        } else {
            const date = new Date(Date.now());
            // console.log(date.getTime(), weather.sys.sunrise * 1000, weather.sys.sunset * 1000)
            if (date.getTime() > weather.sys.sunrise * 1000 && date.getTime() < weather.sys.sunset * 1000) { // If day, only lat
                // sextantTooltip[0].setContent(sextantTextElement.innerHTML);

                return { coords: [lat, '?'], message: 'Essayez la nuit pour déterminer votre longitude grace aux étoiles.' };
            } else {
                // sextantTooltip[0].setContent(sextantTextElement.innerHTML);

                return { coords: [lat, long], message: 'Vous déterminez votre position grace aux étoiles' };
            }
        }
    }

    handleSail() {
        const data = {
            sails: !this.state.sails,
            boatId: this.props.boatData._id
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        }
        fetch(this.props.serverUrl + "boat/sail", options)
            .then(res => res.json().then(json => {
                if (json.message === 'success') {
                    this.setState({ sails: !this.state.sails })
                }
            }));
    }
    handleAnchor() {
        const data = {
            anchor: !this.state.anchor,
            boatId: this.props.boatData._id
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        }
        fetch(this.props.serverUrl + "boat/anchor", options)
            .then(res => res.json().then(json => {
                if (json.message === 'success') {
                    this.setState({ anchor: !this.state.anchor })
                }
            }));
    }
}


export default BottomRightUI;
